import { useRouter } from 'next/router';
import * as React from 'react'
import NodeInputField from '../general/NodeInputField';

import TextContainer from '../layout/TextContainer';
import TerminalOverview from './TerminalOverview';
import TerminalHeuristics from './node-heuristics/TerminalHeuristics';
import TerminalStatusSection from './TerminalStatusSection';
import TerminalStablePeersSection from './channel-heuristics/TerminalStablePeersSection';
import TerminalDisclaimerSection from './TerminalDisclaimerSection';
import TerminalIntroSection from './TerminalIntroSection';
import TerminalAllHeuristicsMatchSection from './TerminalAllHeuristicsMatchSection';
import { ISimpleNode } from '../node/nav/ISimpleNode';
import { useNodeInfo } from '../node/useNodeInfo';


const TerminalDebugger: React.FC = ({ }) => {
  const router = useRouter();
  const { id } = router.query;
  const initialInfo = useNodeInfo(id as string);
  const initialNode = initialInfo.data;

  const [selectedNode, setSelectedNode] = React.useState<ISimpleNode>(undefined);

  async function setUrl(node: ISimpleNode) {
    if (node && node.id === id) {
      return;
    }
    if (!node && !id) {
      return;
    }

    if (node) {
      await router.push({
        pathname: router.pathname,
        query: {
          id: node.id
        }
      })
    } else {
      await router.push({
        pathname: router.pathname,
        query: {}
      })
    }
  }

  React.useEffect(() => {
    if (!initialNode) {
      return;
    }
    if (initialNode.id == selectedNode?.id) {
      return;
    }
    if (!selectedNode){
      setSelectedNode(initialNode);
    }
  }, [initialNode]);

  return (
    <div className="">

      <TextContainer >
        <NodeInputField autoFocus={true} label="Select node" value={selectedNode as ISimpleNode} onChange={async node => {
          setSelectedNode(node);
          setUrl(node);
        }} />
      </TextContainer>

      {selectedNode &&
        <div className="mb-32">
          <TerminalOverview className="mt-12" nodeId={selectedNode.id} />
          

          <TerminalHeuristics nodeId={selectedNode.id} className="mt-24" />
          <TerminalStatusSection className="mt-32" />
          <TerminalStablePeersSection className="mt-24" nodeId={selectedNode.id} />
          <TerminalAllHeuristicsMatchSection className="mt-24" />
        </div>
      }
      <TerminalIntroSection className="mt-8" />
      <TerminalDisclaimerSection className="mt-12" />
    </div>
  );
}

export default TerminalDebugger;

